import {
  Button,
  Card,
  Grid,
  InputAdornment,
  Table,
  TableContainer,
  TableHead,
  TextField,
  Typography,
  TableRow,
  TableBody,
  Box,
  TablePagination,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { RootStateType } from 'src/store/RootReducer';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import DescriptionIcon from '@mui/icons-material/Description';
import { withStyles } from '@mui/styles';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { TableColumnCell } from 'src/components/TableColumnCell';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { getEmployeeLeaves, downloadExcel } from '../../services/leaveService';
import { AppActions } from 'src/store/AppReducer';
import { leavesArray, employeeTypes, employeeStatus } from '../../constant/constant';
import { DatePicker } from '@mui/lab';
import moment from 'moment';
import fileDownload from 'js-file-download';
import SnackBar from 'src/components/SnackBar/SnackBar';
import { userRoles } from 'src/models/leave.enum';
import { useForm } from 'react-hook-form';
import { filterForEmployeeLeaves } from 'src/models/leave';

const EmployeeLeaves = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isReportingManager = useSelector(
    (state: RootStateType) => state.leaveManagementReducer.isReportingManager
  );
  const appUser = useSelector((state: RootStateType) => state.appReducer.user);

  const validateUserRole = (userRole) => {
    const user_role = userRole.split(',');
    if (user_role.includes(userRoles.HR_Manager) || 
      user_role.includes(userRoles.SUPER_USER)) {
      return 'HR_MANAGER';
    } else if (user_role.includes(userRoles.ASSISTANT_HR_MANAGER)) {
      return 'ASSISTANT_HR_MANAGER';
    } else if (user_role.includes(userRoles.HR_EXECUTIVE)) {
      return 'HR_EXECUTIVE';
    } else {
      return 'REPORTING_MANAGER';
    }
  }

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');

  const [isPermissionUserRole, setIsPermissionUserRole] =
    useState<boolean>(false);
  const [employeeLeaves, setEmployeeLeaves] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [isAvailableLeavesArray, setIsAvailableLeavesArray] = useState([]);
  const [toggleFilter, setToggleFilter] = useState(false);
  const [sortIdType, setSortIdType] = useState('');
  const [sortNameType, setSortNameType] = useState('');
  const [isActiveFilterBtn, setIsActiveFilterBtn] = useState<boolean>(false);
  const [clickPageHandler, setClickPageHandler] = useState(1);
  const [initialLoading, setInitialLoading] = useState<boolean>(false);
  const [activeSort, setActiveSort] = useState<string>('');
  
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);

  useEffect(() => {
    const user = window.localStorage.getItem('user');
    const userModel = JSON.parse(user);
    const selectedUserRole = userModel?.Roles;

    const user_role = selectedUserRole?.split(',');
    if (
      user_role.includes('Super User') ||
      user_role.includes('HR Manager') ||
      user_role.includes('Assistant HR Manager') ||
      user_role.includes('HR Executive')
    ) {
      setIsPermissionUserRole(true);
    } else if (isReportingManager) {
      setIsPermissionUserRole(false);
    } else {
      setIsPermissionUserRole(false);
    }
  }, []);

  useEffect(() => {
    const makeApiCall = async () => {
      let filter = modifiedString(isActiveFilterBtn);
      let sort = modifiedSortString(activeSort);
      getEmployeeLeavesList(filter, sort, true);
    };

    const triggerCall = setTimeout(() => {
      setPage(0);
      makeApiCall();
    }, 500);

    return () => clearTimeout(triggerCall);
  }, [searchString]);

  useEffect(() => {
    if(sortIdType) {
      setActiveSort("EmployeeId");
      let filter = modifiedString(isActiveFilterBtn);
      let sort = modifiedSortString('EmployeeId');
      setPage(0);
      getEmployeeLeavesList(filter, sort, true);
    }
    
  }, [sortIdType]);

  useEffect(() => {
    if(sortNameType) {
      setActiveSort("EmployeeName");
      let filter = modifiedString(isActiveFilterBtn);
      let sort = modifiedSortString('EmployeeName');
      setPage(0);
      getEmployeeLeavesList(filter, sort, true);
    }
    
  }, [sortNameType]);

  useEffect(() => {
    if(initialLoading) {
      let filter = modifiedString(isActiveFilterBtn);
      let sort = modifiedSortString(activeSort);
      getEmployeeLeavesList(filter, sort);
    }
    
  }, [limit, clickPageHandler]);

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [isDisabled, setIsDisable] = useState(true);
  const [isDisabledClearBtn, setIsDisabledClearBtn] = useState<boolean>(true);
  const [selectFormDate, setSelectFormDate] = useState('');
  const [selectToDate, setSelectToDate] = useState('');

  const [isSelectToDate, setIsSelectToDate] = useState('');
  const [isSelectFromDate, setIsSelectFromDate] = useState('');
  const [recordCount, setRecordCount] = useState<number>(0);
  const [filterEmployeeType, setFilterEmployeeType] = useState(' ');
  const [filterEmployeeStatus, setFilterEmployeeStatus] = useState(' ');

  const getEmployeeLeavesList = (filter?: any, sort?: any, isResetPage?:boolean) => {
    //set backend page number
    let backendPageNumber = 1;
    backendPageNumber += isResetPage ? 0 : page;

    dispatch(AppActions.showLoader());
    getEmployeeLeaves(validateUserRole(appUser.Roles), limit, backendPageNumber, filter, sort)
      .then(async (res) => {
        if (res?.data?.statusCode === 200) {
          setEmployeeLeaves(res?.data?.data?.employeeLeaveSummery ? res?.data?.data?.employeeLeaveSummery : []);
          setRecordCount(res?.data?.data?.recordCount ? res?.data?.data?.recordCount : 0);
          setInitialLoading(true);
          dispatch(AppActions.hideLoader());
        } else {
          setSnackBarMessage('Failed to retrieve employee leaves.');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          setInitialLoading(true);
          setEmployeeLeaves([]);
          dispatch(AppActions.hideLoader());
        }
      })
      .catch((err) => {
        setSnackBarMessage("Failed to retrieve employee leaves.");
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
        setInitialLoading(true);
        dispatch(AppActions.hideLoader());
      });
  };

  // custom table row with different color
  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem',
      width: '4.2rem'
    }
  })(TableRow);

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
    setClickPageHandler(prevValue => prevValue + 1);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setPage(0);
    setLimit(parseInt(event.target.value));
  };

  const applyFilters = (leaveList: any[]): any[] => {
    return leaveList?.filter(() => {
      let matches = true;

      return matches;
    });
  };

   // set pagination
  const applyPagination = (
    leaveList: any[],
    page: number,
    limit: number
  ): any[] => {
    return leaveList.slice(page * limit, page * limit + limit);
  };

  const [filteredEmpLeaves, setFilteredEmpLeaves] = useState<any>(
    applyFilters(employeeLeaves)
  );
  const [paginatedEmpLeaves, setPaginatedEmpLeaves] = useState<any>(
    applyPagination(filteredEmpLeaves, page, limit)
  );

  useEffect(() => {
    setFilteredEmpLeaves(applyFilters(employeeLeaves));
  }, [employeeLeaves, page, limit, sortIdType, sortNameType]);

  useEffect(() => {
    setPaginatedEmpLeaves(applyPagination(filteredEmpLeaves, 0, limit));
  }, [employeeLeaves, page, limit, filteredEmpLeaves]);

  useEffect(() => {
    // set dynamicTable header
    const availableLeaveArray = [];
    const data = employeeLeaves;
    if (data?.length !== 0) {
      data?.map(async (item) => {
        if (item?.totalLeavesAvailable) {
          availableLeaveArray.push('Employee Type', 'Employee Status', 'Leaves Taken', 'Leave Count');
        }
        if (item?.leaves) {
          if (item?.leaves.length !== 0) {
            item?.leaves.map((leave) => {
              leavesArray.map((type) => {
                if (leave?.typeName === type) {
                  availableLeaveArray.push(type);
                }
              });
            });
          }
        }
      });
    }

    let uniqueAvailableLeaves = availableLeaveArray.filter(
      (value, index, array) => array.indexOf(value) === index
    );
    setIsAvailableLeavesArray(uniqueAvailableLeaves);
  }, [employeeLeaves]);

  const onClear = () => {
    setIsSelectToDate('');
    setIsSelectFromDate('');
    setToDate('');
    setFromDate('');
    setIsDisable(true);
    setIsDisabledClearBtn(true);
    setSelectFormDate('');
    setSelectToDate('');
    setIsActiveFilterBtn(false);
    setFilterEmployeeType('');
    setFilterEmployeeStatus('');
    setPage(0);
    let filter = modifiedString(false);
    let sort = modifiedSortString(activeSort);
    getEmployeeLeavesList(filter, sort, true);
  };

  const onFilter = () => {
    setPage(0);
    setIsActiveFilterBtn(true);
    let filter = modifiedString(true);
    let sort = modifiedSortString(activeSort);
    getEmployeeLeavesList(filter, sort, true);
  };

  const downloadFile = (filter?: any, sort?: any) => {
    dispatch(AppActions.showLoader());
    downloadExcel(validateUserRole(appUser.Roles), filter, sort)
      .then((res) => {
        if(res.status === 200) {
          fileDownload(res.data, 'employees-leaves-report.xlsx');
        }else{
          setSnackBarMessage('No leaves were taken in selected date range.');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
        }
        dispatch(AppActions.hideLoader());
      })
      .catch((err) => {
        setSnackBarMessage('No leaves were taken in selected date range.');
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
        dispatch(AppActions.hideLoader());
      });
  };

  const currentYear = new Date().getFullYear();

  //filter option
  const { getValues } = useForm<filterForEmployeeLeaves>();

  const modifiedString = (isActiveFilter?: boolean) => {
    let filter = getValues();
    let startDate = moment(selectFormDate).format('DD/MM/YYYY');
    let endDate = moment(selectToDate).format('DD/MM/YYYY');
    filter.isEmpty = true;

    if (searchString) {
      filter.mainSearchParam = searchString;
      filter.isEmpty = false;
    }

    if (selectFormDate && isActiveFilter) {
      filter.fromDate = startDate;
      filter.isEmpty = false;
    }

    if (selectToDate && isActiveFilter) {
      filter.toDate = endDate;
      filter.isEmpty = false;
    }

    if (filterEmployeeType && isActiveFilter) {
      filter.employeeType = filterEmployeeType;
      filter.isEmpty = false;
    }

    if (filterEmployeeStatus && isActiveFilter) {
      filter.employeeStatus = filterEmployeeStatus;
      filter.isEmpty = false;
    }

    if (!filter.isEmpty) {
      return JSON.stringify(filter)
        .replace('"isEmpty":false,', '')
        .replace('{', '')
        .replace('}', '')
        .replace(/\"/g, '');
    } else {
      return null;
    }
  };

  //sort option
  const modifiedSortString = (activeSortOption?: string) => {
    let sort = getValues();
    sort.isEmpty = true;

    if (sortIdType && activeSortOption === 'EmployeeId') {
      sort.employee_id = sortIdType;
      sort.isEmpty = false;
    }

    if(sortNameType && activeSortOption === 'EmployeeName') {
      sort.name = sortNameType;
      sort.isEmpty = false;
    }

    if (!sort.isEmpty) {
      return JSON.stringify(sort)
        .replace('"isEmpty":false,', '')
        .replace('{', '')
        .replace('}', '')
        .replace(/\"/g, '');
    } else {
      return null;
    }
  };

  return (
    <>
      <Grid sx={{ mx: 3 }}>
        <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
          <Grid item>
            <Typography
              style={{
                marginLeft: '0px',
                fontWeight: '700',
                fontSize: '16px',
                fontFamily:
                  'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
              }}
            >
              <span
                style={{
                  cursor: 'pointer',
                  marginRight: '3px'
                }}
                onClick={() => {
                  navigate('/leave-management');
                }}
              >
                Leave Management
              </span>
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: '550',
                  color: '#223354'
                }}
              >
                / Employee Leaves
              </span>
            </Typography>
            <Typography variant="subtitle2"></Typography>
          </Grid>
          <Grid item>
            <Button
              sx={{
                mr: 2,
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/apply-leave`);
              }}
            >
              Apply Leave
            </Button>
            {/* <Button
              sx={{
                mr: 2,
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/apply-wfh`);
              }}
            >
              Apply Work From Home
            </Button> */}
            <Button
              sx={{
                mr: 2,
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/apply-lieu-leave`);
              }}
            >
              Lieu Leave Eligibility
            </Button>
            {isPermissionUserRole && (
              <Button
                sx={{
                  mr: 2,
                  mt: { xs: 2, md: 0 },
                  fontSize: '11px',
                  fontWeight: 'normal'
                }}
                variant="contained"
                style={{ height: '1.75rem' }}
                onClick={(e) => {
                  navigate(`/leave-management/RM-pending-requests`);
                }}
              >
                PM/RM Pending Requests
              </Button>
            )}
            <Button
              sx={{
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/my-leave-history/id`);
              }}
            >
              My Leave History
            </Button>
          </Grid>
        </Grid>
        <Card>
          <Grid sx={{ m: 2 }}>
            <TextField
              sx={{ width: 320, mr: 2 }}
              size="small"
              placeholder="Search (Employee Name)"
              InputProps={{
                style: { fontSize: '12px', height: '1.75rem' },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      sx={{ color: '#d3d3d3' }}
                      style={{ fontSize: '15px' }}
                    />
                  </InputAdornment>
                )
              }}
              value={searchString}
              onChange={(e) => {
                setSearchString(e.target.value);
              }}
            />
            <Button
              sx={{
                mt: { xs: 2, md: 0 },
                color: `${!toggleFilter && 'gray'}`
              }}
              variant="outlined"
              startIcon={<FilterListIcon style={{ fontSize: '15px' }} />}
              style={{ height: '1.75rem', fontSize: '12px' }}
              onClick={() => {
                setToggleFilter(!toggleFilter);
                onClear();
              }}
            >
              Filters
            </Button>
          </Grid>
          {toggleFilter && (
            <Grid px={2} pb={2} style={{margin: 0}}>
              <Grid
                container
                spacing={2}
                style={{
                  paddingTop: 2,
                  paddingBottom: 2,
                  justifyContent: 'between'
                }}
              >
              <Grid
                  item
                  xs={3}
                >
                  <InputLabel
                    style={{
                      fontSize: '10px',
                      fontWeight: 'bold'
                    }}
                  >
                    Employee Type
                  </InputLabel>
                  <FormControl fullWidth>
                    <Select
                      id="employeeType"
                      sx={{ mt: 1 }}
                      style={{
                        fontSize: '10px',
                        height: '2rem'
                      }}
                      fullWidth
                      size="small"
                      value={filterEmployeeType || ' '}
                      onChange={(e) => {
                        setFilterEmployeeType(e.target.value);
                        setIsDisable(false);
                        setIsDisabledClearBtn(false);
                      }}
                    >
                      <MenuItem
                              style={{ display: 'none' }}
                              selected
                              disabled
                              value={' '}
                            >
                              Select Employee Type
                      </MenuItem>
                      {(employeeTypes).map((item, i) => {
                            return (
                              <MenuItem value={item} key={i}>
                                {item}
                              </MenuItem>
                            );
                          })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                      item
                      xs={3}
                    >
                    <InputLabel
                    style={{
                      fontSize: '10px',
                      fontWeight: 'bold'
                    }}
                  >
                    Employee Status
                  </InputLabel>
                      <FormControl fullWidth>
                        <Select
                          id="employeeStatus"
                          sx={{ mt: 1 }}
                          style={{
                            fontSize: '10px',
                            height: '2rem'
                          }}
                          fullWidth
                          size="small"
                          value={filterEmployeeStatus || ' '}
                          onChange={(e) => {
                            setFilterEmployeeStatus(e.target.value);
                            setIsDisable(false);
                            setIsDisabledClearBtn(false);
                          }}
                        >
                          <MenuItem
                              style={{ display: 'none' }}
                              selected
                              disabled
                              value={' '}
                            >
                              Select Employee Status
                        </MenuItem>
                          {(employeeStatus).map((item, i) => {
                            return (
                              <MenuItem value={item} key={i}>
                                {item}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                </Grid>
                <Grid
                  item
                  xs={3}
                >
                  <InputLabel
                    style={{
                      fontSize: '10px',
                      fontWeight: 'bold'
                    }}
                  >
                    From
                  </InputLabel>
                  <div style={{ marginTop: 7 }}>
                    <FormControl fullWidth>
                      <DatePicker
                        InputProps={{
                          className: 'date-picker-leaveManagement'
                        }}
                        maxDate={new Date(currentYear, 11, 31)}
                        renderInput={(params) => (
                          <TextField {...params} id="fromDate" />
                        )}
                        value={selectFormDate ? selectFormDate : null}
                        onChange={(newValue) => {
                          if (newValue) {
                            setIsActiveFilterBtn(false);
                            setIsDisabledClearBtn(false);
                            setIsSelectFromDate('');
                            setFromDate(
                              moment(newValue).format('DD/MM/YYYY')
                            );
                            setSelectFormDate(
                              moment(newValue).format('YYYY-MM-DD')
                            );
                            setToDate('');
                            setSelectToDate('');
                            setIsDisable(true);
                            setIsSelectToDate('To date is mandatory field');
                          }
                        }}
                      />
                    </FormControl>
                  </div>
                  {isSelectFromDate && (
                    <>
                      <Typography
                        style={{
                          fontSize: '11px'
                        }}
                        color="red"
                      >
                        {isSelectFromDate}
                      </Typography>
                    </>
                  )}
                </Grid>
                <Grid
                  item
                  xs={3}
                >
                  <InputLabel
                    style={{
                      fontSize: '10px',
                      fontWeight: 'bold'
                    }}
                  >
                    To
                  </InputLabel>
                  <div style={{ marginTop: 7 }}>
                    <FormControl fullWidth>
                      <DatePicker
                        disabled={!fromDate}
                        InputProps={{
                          className: 'date-picker-leaveManagement'
                        }}
                        minDate={new Date(selectFormDate)}
                        maxDate={new Date(currentYear, 11, 31)}
                        renderInput={(params) => (
                          <TextField {...params} id="filterToDate" />
                        )}
                        value={selectToDate ? selectToDate : null}
                        onChange={(newValue) => {
                          if (newValue) {
                            setIsActiveFilterBtn(false);
                            setIsDisabledClearBtn(false);
                            setIsSelectToDate('');
                            setToDate(moment(newValue).format('DD/MM/YYYY'));
                            setSelectToDate(
                              moment(newValue).format('YYYY-MM-DD')
                            );
                            if (!fromDate) {
                              setIsDisable(true);
                              setIsSelectFromDate(
                                'Form date is mandatory field'
                              );
                            } else {
                              setIsDisable(false);
                            }
                          }
                        }}
                      />
                    </FormControl>
                  </div>
                  {isSelectToDate && (
                    <>
                      <Typography
                        style={{
                          fontSize: '11px'
                        }}
                        color="red"
                      >
                        {isSelectToDate}
                      </Typography>
                    </>
                  )}
                </Grid>
                <Grid
                  container
                  xs={9}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: 16,
                    marginLeft: 'auto'
                  }}
                >
                  <Button
                    variant="outlined"
                    style={{
                      height: '1.75rem',
                      fontSize: '12px'
                    }}
                    id="filterClear"
                    disabled={isDisabledClearBtn}
                    className={isDisabledClearBtn &&'clear-btn'}
                    onClick={() => onClear()}
                  >
                    Clear
                  </Button>
                  <Button
                    id="filterSubmit"
                    variant="outlined"
                    type="button"
                    style={{
                      height: '1.75rem',
                      fontSize: '12px',
                      marginLeft: '1rem'
                    }}
                    onClick={() => onFilter()}
                    disabled={isDisabled}
                    className={isDisabled &&'filter-btn'}
                  >
                    Filter
                  </Button>
                  {isPermissionUserRole && (
                    <Button
                      id="filterDownload"
                      variant="contained"
                      type="button"
                      style={{
                        height: '1.75rem',
                        fontSize: '12px',
                        marginLeft: '1rem'
                      }}
                      startIcon={<DescriptionIcon fontSize="small" />}
                      onClick={() => {
                        let filter = modifiedString(true);
                        let sort = modifiedSortString(activeSort);
                        downloadFile(filter, sort)
                      }}
                      disabled={isDisabled}
                    >
                      Download Report
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          )}
          <Divider />
          <TableContainer>
            <Table size="small">
              <TableHead>
                <CustomTableRow>
                  <TableHeaderCell
                    content="Employee ID"
                    sort
                    setSortType={setSortIdType}
                    sortType={sortIdType}
                    smallFont
                    sticky
                  />
                  <TableHeaderCell
                    content="Employee Name"
                    sort
                    setSortType={setSortNameType}
                    sortType={sortNameType}
                    smallFont
                    leftSticky
                  />
                  {isAvailableLeavesArray.map(
                    (item) => {
                      if(item === 'Employee Type') { 
                        return(
                          <TableHeaderCell content={'Employee Type'} smallFont />
                      )}
                      if(item === 'Employee Status') { 
                        return(
                          <TableHeaderCell content={'Employee Status'} smallFont />
                      )}
                      if(item === 'Leaves Taken') { 
                        return(
                          <TableHeaderCell content={'Leaves Taken'} smallFont />
                      )}
                      if(item === 'Leave Count') { 
                        return(
                          <TableHeaderCell content={'Leave Count'} smallFont />
                      )}
                    }
                  )}
                  {leavesArray.map((leave) => {
                    return isAvailableLeavesArray.map(
                      (item) =>
                        item === leave && (
                          <TableHeaderCell content={item} smallFont />
                        )
                    );
                  })}
                  <TableHeaderCell content="Action" smallFont sticky />
                </CustomTableRow>
              </TableHead>
              <TableBody>
                {paginatedEmpLeaves.length !== 0 &&
                  paginatedEmpLeaves.map((item) => {
                    return (
                      <TableRow>
                        <TableColumnCell sticky borderBottom>
                          <Typography
                            paddingBottom="0.25rem"
                            paddingTop="0.5rem"
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            gutterBottom
                            noWrap
                          >
                            {item?.employeeId ? item.employeeId : '---'}
                          </Typography>
                        </TableColumnCell>
                        <TableColumnCell leftSticky>
                          <Typography
                            paddingBottom="0.25rem"
                            paddingTop="0.5rem"
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            gutterBottom
                            noWrap
                          >
                            {item?.employeeName ? item.employeeName : '---'}
                          </Typography>
                        </TableColumnCell>
                        {isAvailableLeavesArray.map((type) => {
                          if (type === 'Employee Type') {
                            return (
                              <TableColumnCell>
                                <div
                                  style={{
                                    display: 'flex',
                                    fontSize: '11px',
                                    justifyContent: 'center',
                                    maxWidth: '5rem'
                                  }}
                                >
                                  {item?.employeeType ? item.employeeType : 'N/A'}
                                </div>
                              </TableColumnCell>
                            );
                          }
                          if (type === 'Employee Status') {
                            return (
                              <TableColumnCell>
                                <div
                                  style={{
                                    display: 'flex',
                                    fontSize: '11px',
                                    justifyContent: 'center',
                                    maxWidth: '5rem'
                                  }}
                                >
                                  {item?.resign ? 'Inactive' : 'Active'}
                                </div>
                              </TableColumnCell>
                            );
                          }
                          if (type === 'Leaves Taken') {
                            return (
                              <TableColumnCell>
                                <div
                                  style={{
                                    display: 'flex',
                                    fontSize: '11px',
                                    justifyContent: 'center',
                                    maxWidth: '5rem'
                                  }}
                                >
                                  {item.totalLeavesAvailable === 'null' ||
                                  item.totalLeavesAvailable === '0.0' ? (
                                    'N/A'
                                  ) : (
                                    <span>
                                      {item?.totalLeavesAvailable * 1 -
                                        item?.balance * 1}
                                    </span>
                                  )}
                                </div>
                              </TableColumnCell>
                            );
                          }
                          if (type === 'Leave Count') {
                            return (
                              <TableColumnCell>
                                <div
                                  style={{
                                    display: 'flex',
                                    fontSize: '11px',
                                    justifyContent: 'center',
                                    maxWidth: '5rem'
                                  }}
                                >
                                  {item.balance === 'null' ||
                                  item.totalLeavesAvailable === 'null' ||
                                  item.totalLeavesAvailable === '0.0' ? (
                                    'N/A'
                                  ) : (
                                    <span>{item?.balance * 1}</span>
                                  )}
                                </div>
                              </TableColumnCell>
                            );
                          }
                        })}
                        {leavesArray.map((type) => {
                          const matchingLeave = item.leaves.find(
                            (leave) => leave?.typeName === type
                          );
                          if (matchingLeave) {
                            return (
                              <TableColumnCell key={type}>
                                <div
                                  style={{
                                    display: 'flex',
                                    fontSize: '11px',
                                    justifyContent: 'center',
                                    maxWidth: '5rem'
                                  }}
                                >
                                  {matchingLeave.totalLeavesAvailable ===
                                    'null' ||
                                  matchingLeave.totalLeavesAvailable ===
                                    '0.0' ? (
                                    <>
                                      {matchingLeave?.typeName ===
                                        'Lieu Leave' &&
                                      item?.employeeType === 'Permanent' ? (
                                        <>
                                          <span style={{ color: 'blue' }}>
                                            0
                                          </span>
                                          <span>/0</span>
                                        </>
                                      ) : (
                                        'N/A'
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {matchingLeave?.typeName ===
                                      'No Pay Leave' ? (
                                        <span>
                                          {matchingLeave?.totalLeavesTaken ===
                                            'null' ||
                                          matchingLeave?.totalLeavesTaken == null
                                            ? 0 : matchingLeave.totalLeavesTaken * 1}
                                        </span>
                                      ) : (
                                        <>
                                          <span style={{ color: 'blue' }}>
                                            {matchingLeave?.totalLeavesAvailable *
                                              1 -
                                              matchingLeave?.balance * 1}
                                          </span>
                                          <span>
                                            /{matchingLeave?.totalLeavesAvailable * 1}
                                          </span>
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>
                              </TableColumnCell>
                            );
                          } else {
                            return null;
                          }
                        })}
                        <TableColumnCell sticky>
                          <VisibilityOutlinedIcon
                            onClick={() => {
                              navigate(
                                `/leave-management/my-leave-history/${item?.employeeId}?name=${item?.employeeName}`
                              );
                            }}
                            style={{
                              fontSize: '17px',
                              cursor: 'pointer'
                            }}
                          />
                        </TableColumnCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          {paginatedEmpLeaves?.length === 0 && (
            <Typography
              style={{
                fontSize: '15px',
                fontWeight: 'bold',
                margin: '1rem',
                textAlign: 'center'
              }}
              variant="body2"
            >
              No Records Found
            </Typography>
          )}
          <Box p={2}>
            <TablePagination
              sx={{
                fontSize: '12px',
                '.MuiTablePagination-displayedRows': {
                  fontSize: '12px'
                },
                '.MuiTablePagination-selectLabel': {
                  fontSize: '12px'
                }
              }}
              component="div"
              count={recordCount}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[10, 20, 30, 40, 50]}
            />
          </Box>
        </Card>
        <SnackBar
          snackBarOpen={snackBarOpen}
          setSnackBarOpen={setSnackBarOpen}
          snackBarMessage={snackBarMessage}
          snackbarSeverity={snackbarSeverity}
        />
      </Grid>
    </>
  );
};

export default EmployeeLeaves;
